export default __webpack_public_path__ + "static/media/philo1.f04c4621.png";